import { base64ToFile } from "web_myplann/Infrastructure/Utils/FileUtils";
import type { PickedAttachment } from "web_myplann/Shared/Types/PickedAttachment";
import {
	type AttachmentPickPayload,
	AttachmentPickStatuses,
} from "web_myplann/Utils/WebViewModel";

export const resolvePickedAttachment = (
	payload: AttachmentPickPayload,
): PickedAttachment => {
	if (payload.status === AttachmentPickStatuses.cancelled) {
		return { status: AttachmentPickStatuses.cancelled };
	}

	const { base64, filename } = payload.file ?? {};

	if (payload.status === AttachmentPickStatuses.error || !base64 || !filename) {
		return { status: AttachmentPickStatuses.error };
	}

	try {
		return {
			status: AttachmentPickStatuses.picked,
			file: base64ToFile(base64, filename),
			filename,
		};
	} catch {
		return { status: AttachmentPickStatuses.error };
	}
};
